<template>
  <div class="container main-container">
    <div class="align-items-center justify-content-center text-center">
      <hr class="my-1" />
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img class="img-fluid" src="../assets/menu-page-1.png" alt="First slide">
          </div>
          <div class="carousel-item">
            <img class="img-fluid" src="../assets/menu-page-2.png" alt="First slide">
          </div>
          <div class="carousel-item">
            <img class="img-fluid" src="../assets/menu-page-3.png" alt="Second slide">
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuCard"
}
</script>

<style scoped>
.main-container {
  height: 100%;
  background-image: url(../assets/wintiWappen.png);
  background-color: #191919;
  color: whitesmoke;
}
</style>
